import React, { useEffect } from 'react'
import Loader from '../search-trip/components/Loader'
import ProgressBar from './ProgressBar'
import { useReservationContext } from './ReservationContext'
import ClockPink from '@assets/img/reservation/clock-pink.svg'

const Header = () => {
    const { loading, offer, errors, t} = useReservationContext()



    return (
        <div className="trip-reservation__header">
            <ProgressBar />
            <div className="trip-reservation__header-headings">
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <div className="trip-reservation__code">
                            {t('offer-code')}: {offer.vcOfferId ? offer.vcOfferId : '-'}
                        </div>
                        <div className="trip-reservation__header-heading">
                            {offer.offerName ? offer.offerName : '-'} - {offer.country ? offer.country : '-'}
                        </div>
                        <div className="trip-reservation__header-subheader">
                        {t('offer-code-info')}
                            <div>
                                <a href="tel:+48585858058">+48 58 58 58 058</a>&nbsp;/&nbsp;
                                <a href="mailto:rezerwacja@vacationclub.pl" title="">
                                    rezerwacja@vacationclub.pl
                                </a>
                            </div>
                        </div>
                        <div className="trip-reservation__availability-alert">
                            <img src={ClockPink} alt="Clock" />
                            <b>{t('do-not-delay')} !</b>
                            <span>{t('price-may-change')}</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default Header
